<template>
  <Teleport to="body">
    <div
      v-if="open"
      class="estrut-modal-overlay"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="titleId"
    >
      <div class="estrut-modal estrut-modal--sm" :class="{ 'estrut-modal--warn': !singleAction }">
        <div class="estrut-modal__accent" aria-hidden="true" />

        <header class="estrut-modal__header">
          <div class="estrut-modal__icon" :class="singleAction ? 'estrut-modal__icon--accent' : 'estrut-modal__icon--warn'">
            <svg v-if="singleAction" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <svg v-else fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div class="estrut-modal__titles">
            <h2 :id="titleId" class="estrut-modal__title">{{ title }}</h2>
            <p v-if="message" class="estrut-modal__subtitle">{{ message }}</p>
          </div>
          <button type="button" class="estrut-modal__close" :aria-label="t('common.close')" @click="$emit('cancel')">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </header>

        <footer class="estrut-modal__footer">
          <button
            v-if="!singleAction"
            type="button"
            class="estrut-modal__btn estrut-modal__btn--secondary"
            @click="$emit('cancel')"
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
            {{ t('common.cancel') }}
          </button>
          <button
            type="button"
            class="estrut-modal__btn"
            :class="singleAction ? 'estrut-modal__btn--primary' : 'estrut-modal__btn--danger'"
            :disabled="loading"
            @click="$emit('confirm')"
          >
            <svg v-if="loading" class="estrut-modal__btn-spinner" fill="none" viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" />
              <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            <svg v-else-if="singleAction" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
            <svg v-else fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            {{ loading ? t('common.loading') : (confirmLabel || (singleAction ? t('common.close') : t('common.yes'))) }}
          </button>
        </footer>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

defineProps({
  open: { type: Boolean, default: false },
  title: { type: String, required: true },
  message: { type: String, default: '' },
  confirmLabel: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  titleId: { type: String, default: 'estrut-confirm-title' },
  singleAction: { type: Boolean, default: false }
})

defineEmits(['cancel', 'confirm'])

const { t } = useI18n()
</script>

<style src="./estruturacao-modals.css"></style>
